<template>
  <div :class="classes" v-loading="loading" element-loading-text="导入中...">
    <pt-page-title title="医生管理" isSearch @search="search" @emptySearch="emptySearch" placeholder="请输入医生姓名或手机号搜索"
      :searchKey="searchKey" @searchNo="searchNo" isParams>

      <!-- <template slot="before-left">
        <el-button type="primary" @click="createCompany">创建医生</el-button>
        <el-button type="primary" @click="exportDoctorQrcode" :loading="exportLoading">二维码导出</el-button>
         <el-button type="primary" @click="exportHistory">导出历史</el-button>
      </template> -->
    </pt-page-title>
        <pt-page-menu-filter :tabs="tabs" v-model="selectTab" state="type"></pt-page-menu-filter>
     <pt-page-factor-filter :labels="doctorFilterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="primary" @click="createCompany" v-if="HAS_PERM_DOCTOR_OPERATION">创建医生</el-button>
            <el-upload
              action=""
              ref="excel"
              :class="$style['upload-demo']"
              :multiple="false"
              :http-request="uploadFile"
              :on-change="changHandler"
              :show-file-list="false"
              v-model="excel" name="excel">
              <el-button type="primary">医生导入</el-button>
              <br>
            </el-upload>
             <a :href="$privateResourcesUrlDownload+'templates/医护人员导入模板.xlsx'" :class="$style['download-demo']">
            <el-button type="text">下载文件模版</el-button>
            </a>
        <el-button type="primary" @click="exportDoctorQrcode()" :loading="exportLoading">医生导出</el-button>
        <el-button type="primary" @click="exportDoctorQrcode(true)" :loading="exportLoading">二维码导出</el-button>
         <el-button type="primary" @click="exportHistory">导出历史</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
    <pt-doctor-table :tableLabels="tableLabels" :isFromRouter="isFromRouter" ref="table" :paramsData="paramsData"
      :class="$style['pt-doctor-table']">
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="doctor-opretion-icon">
          <i class="iconfont icon-xiangqing" @click="goDetail(scope.row)"></i>
          <i class="iconfont icon-bianji" v-if="HAS_PERM_DOCTOR_OPERATION" @click="goEdit(scope.row)"></i>
          <i class="iconfont icon-shanchu" v-if="HAS_PERM_DOCTOR_OPERATION" @click="goDelete(scope.row)"></i>
          </div>
        </template>
      </el-table-column>
    </pt-doctor-table>
    <err-doctor-dialog :dialogVisible="isDialogShow" :dialogTitle="dialogTitle" @close="closeDialog" :errDoctorList="errDoctorList"></err-doctor-dialog>
  </div>
</template>

<script>
import errDoctorDialog from './err-doctor-dialog'
import {
  doctorTableLabels, doctorFilterLabels, doctorTabs } from '../hospital-and-doctor-manage'
import ptDoctorTable from './pt-doctor-table/withData'
import { isEmptyObject } from '@/utils/formUtils'
import { hasPermissions } from 'utils/permissions'

import {
  emptyObject
} from '@/utils/lifebankUtils' // 组件class前缀
const prefixCls = 'pt-doctor-manage'
const PERM_DOCTOR_OPERATION = 'PERM_DOCTOR_OPERATION'// 所有分子公司的增删权限
const PERM_REGION_DOCTOR_OPERATION = 'PERM_REGION_DOCTOR_OPERATION'// 自己所属分子公司的增删权限
export default {
  name: 'pt-doctor-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableData () {
      return this.$refs.table.tableData
    },
    HAS_PERM_DOCTOR_OPERATION () {
      return (this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_DOCTOR_OPERATION)) ||
      (this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_REGION_DOCTOR_OPERATION))
    }
  },
  props: {
    exportLoading: {
      type: Boolean
    }
  },
  components: {
    errDoctorDialog,
    ptDoctorTable
  },
  data () {
    return {
      tableLabels: doctorTableLabels,
      params: {},
      paramsData: {},
      isFromRouter: false,
      searchKey: null,
      doctorFilterLabels: doctorFilterLabels,
      excel: '',
      isDialogShow: false,
      dialogTitle: '医生导入信息提示',
      errDoctorList: {},
      loading: false,
      tabs: doctorTabs,
      selectTab: null
    }
  },
  watch: {
    selectTab: {
      handler: function (val) {
        if (val === 'obs') {
          this.$set(this.paramsData, 'joinObstetricsQA', true)
        } else {
          if (this.paramsData.joinObstetricsQA) this.$delete(this.paramsData, 'joinObstetricsQA')
        }
        if (this.paramsData.type) this.$delete(this.paramsData, 'type')
      },
      immediate: true
    }
  },
  methods: {
    closeDialog () {
      this.isDialogShow = false
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.excel = fileList
    },
    uploadFile (param) {
      this.loading = true
      this.uploadForm = new FormData()
      this.uploadForm.append('file', this.excel[0].raw)
      this.$store.dispatch('importDoctorList', this.uploadForm).then(res => {
        this.loading = false
        this.getTableData()
        this.isDialogShow = true
        this.errDoctorList = res
      }).catch((error) => {
        this.loading = false
        this.$message.error(error)
      })
    },
    change () {},
    exportHistory () {
      this.$router.push('/export-history/doctor-qr-code?name=doctor')
    },
    exportDoctorQrcode (isQrcode) {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          if (this.params && !isEmptyObject(this.params)) {
            for (var key in this.params) {
              if (!this.params[key]) {
                this.$delete(this.params, key)
              }
              if (key === 'createdtime') {
                this.$delete(this.params[key], 'index')
                this.params = { ...this.params, ...this.params[key] }
                this.$delete(this.params, key)
                this.$delete(this.params, 'index')
              }
            }
          }

          let data = {
            searchKey: this.searchKey,
            ...this.params
          }

          for (var key1 in data) {
            if (key1 === 'proviveAndCity') {
              data = { ...data, ...data[key1] }
              this.$delete(data, key1)
              data.provinceName && this.$delete(data, 'provinceName')
              data.cityName && this.$delete(data, 'cityName')
            }
          }
          // this.paramsData.searchKey = this.searchKey
          // this.params.searchKey = this.searchKey ? this.searchKey : null
          let param = {
            data: data,
            url: isQrcode ? 'exportDoctorQrcode' : 'exportDoctorList'
          }
          this.$emit('exportDoctorQrcode', param)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.queryParams)
      emptyObject(this.params)
      this.paramsData = {
        searchKey: val
      }
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.paramsData, 'searchKey')
    },
    searchNo (val) {
      this.searchKey = val
    },
    getTableData () {
      this.$refs.table.getTableData()
    },
    Filter (isFromRouter, val) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'createdtime') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
          this.$delete(this.params, 'index')
        }
      }
      this.paramsData = JSON.parse(JSON.stringify(this.params))
      for (var key1 in this.paramsData) {
        if (key1 === 'proviveAndCity') {
          this.paramsData = { ...this.paramsData, ...this.paramsData[key1] }
          this.$delete(this.paramsData, key1)
          this.paramsData.provinceName && this.$delete(this.paramsData, 'provinceName')
          this.paramsData.cityName && this.$delete(this.paramsData, 'cityName')
        }
      }

      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      for (var key in this.paramsData) {
        this.$delete(this.paramsData, key)
      }
      for (var key1 in this.params) {
        this.$delete(this.params, key1)
      }
      if (this.selectTab === 'obs') {
        this.$set(this.paramsData, 'joinObstetricsQA', true)
      }
      this.$refs.filter.getAddRouter(this.paramsData)
    },
    goEdit (val) {
      this.$router.push('/doctor-manage/doctor-form/true/' + val.id)
    },
    goDelete (val) {
      this.$confirm('删除该医生后，其手机号码对应的用户账户仍然保留，该账户将被解除医生身份，且该账户将被重置到普通用户对应的会员等级，确认删除吗？？', '删除医生', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.$emit('deleteDoctor', val.id)
      })
    },
    goDetail (val) {
      this.$router.push('./doctor-detail/' + val.id)
    },
    createCompany () {
      this.$router.push('/doctor-manage/doctor-form/false/0')
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
.pt-doctor-table{
    :global{
      .doctor-opretion-icon{
        overflow: auto
      }
  .iconfont{
        margin-right: 10px;
    }
    }
}
.upload-demo{
  display: inline-block;
}
.download-demo{
  margin-right:.3rem
}

</style>
